import { Controller } from "@hotwired/stimulus";
import { api } from "../services/api";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = { selectPath: String };
  declare readonly hasSelectPathValue: boolean;
  declare readonly selectPathValue: string;
  static targets = [ 'rowSelect' ];
  declare readonly rowSelectTargets: HTMLInputElement[];
  selectedIds: Set<number> = new Set([]);

  connect() {
  }

  postSelected = () => {
    if (!this.hasSelectPathValue) return;

    return api.postTurbo(this.selectPathValue, { ids: Array.from(this.selectedIds) });
  }

  selectAll = e => {
    const checked = e.currentTarget.checked;
    this.rowSelectTargets.forEach(input => input.checked = checked);
    this.updatedSelectedIds();
    this.postSelected();
  }

  rowId = el => Number(el.closest('tr').getAttribute('data-id'));

  selectRow = e => {
    const checked = e.currentTarget.checked,
        id = this.rowId(e.currentTarget);
    if (checked) this.selectedIds.add(id);
    else this.selectedIds.delete(id);
    this.postSelected();
  }

  updatedSelectedIds = () => {
    this.selectedIds = new Set(
        this.rowSelectTargets.filter(input => input.checked)
            .map(input => Number(this.rowId(input)))
    );
  }

  linkClick = e => {
    const targetIsLink = e.target.tagName === 'A',
        targetIsBtn = e.target.tagName === 'BUTTON';
    if (targetIsLink || targetIsBtn) return;
    const { url } = e.currentTarget.dataset;
    if (!!url?.length) Turbo.visit(url, { frame: '_top' });
  }
}
